import { CustomPermission, ICustomPermission } from './custom-permission.model';
import { CustomRole, ICustomRole } from './custom-role.model';
export interface ICustomUser {
    token: string;
    id: number;
    active: boolean;
    first_name: string;
    last_name: string;
    email: string;
    customer_id: number;
    permissions: CustomPermission[];
    role: CustomRole;
    created_at: string;
    updated_at: string;
    email_verified_at: string;
}

export class CustomUser implements ICustomUser {
    public token: string;
    public id: number;
    public active: boolean;
    public first_name: string; // tslint:disable-line: variable-name
    public last_name: string; // tslint:disable-line: variable-name
    public email: string;
    public customer_id: number; // tslint:disable-line: variable-name
    public role: CustomRole;
    public permissions: CustomPermission[];
    public created_at: string; // tslint:disable-line: variable-name
    public updated_at: string; // tslint:disable-line: variable-name
    public email_verified_at: string; // tslint:disable-line: variable-name

    constructor(options: {
        token?: string,
        id?: number,
        active?: boolean,
        first_name?: string,
        last_name?: string,
        email?: string,
        customer_id?: number,
        permissions?: CustomPermission[],
        role?: CustomRole,
        created_at?: string,
        updated_at?: string,
        email_verified_at?: string,
    } = {}) {
        this.token = options.token || '';
        this.id = options.id || null;
        this.active = !!options.active;
        this.first_name = options.first_name || '';
        this.last_name = options.last_name || '';
        this.email = options.email || '';
        this.customer_id = options.customer_id || 1;
        if (options.permissions && options.permissions.length) {
            this.permissions = options.permissions.map((permission: ICustomPermission) => {
                return new CustomPermission(permission);
            });
        } else {
            this.permissions = [];
        }
        this.role = options.role || null;
        this.created_at = options.created_at || '';
        this.updated_at = options.updated_at || '';
        this.email_verified_at = options.email_verified_at || '';

    }
}
